import { render, staticRenderFns } from "./channelSettings.vue?vue&type=template&id=77520c36&"
import script from "./channelSettings.vue?vue&type=script&lang=js&"
export * from "./channelSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports